import CHECKBOX_EMPTY from "@/assets/icons/checkbox-empty.svg";
import CHECKBOX_FILLED from "@/assets/icons/checkbox-filled.svg";
import CHECKBOX_EMPTY_DISABLED from "@/assets/icons/checkbox-empty-disabled.svg";
import CHECKBOX_FILLED_DISABLED from "@/assets/icons/checkbox-filled-disabled.svg";
import { FC } from "react";
import "./style.scss";

interface CheckBoxPropTypes {
  checked: boolean;
  disabled?: boolean;
  onChange?: () => void;
}

const CheckBox: FC<CheckBoxPropTypes> = ({
  checked,
  disabled,
  onChange = () => {},
}) => {
  const onClick = () => {
    if (!disabled) {
      onChange();
    }
  };

  return (
    <div className="checkbox-component" onClick={onClick}>
      {!checked ? (
        <img
          src={disabled ? CHECKBOX_EMPTY_DISABLED : CHECKBOX_EMPTY}
          alt="checkbox-icon"
          className={disabled ? "" : "hover-glow"}
        />
      ) : (
        <img
          src={disabled ? CHECKBOX_FILLED_DISABLED : CHECKBOX_FILLED}
          alt="checkbox-icon"
          className={disabled ? "" : "hover-glow"}
        />
      )}
    </div>
  );
};

export default CheckBox;
